import { c as _c } from "react/compiler-runtime";
import { Badge } from '@systemeio/components';
import { InfoCircleIcon } from '@systemeio/icons';
import { centsToUnits } from '@systemeio/util';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { Button, Loader, Modal, Popover } from 'shared/components';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { getQuery } from 'shared/route-query/utils/get-query';
import { currencyFormat } from 'shared/utils/currency-format';
import { dateFormat } from 'shared/utils/date-time-format';
import { twJoin } from 'tailwind-merge';
import { InvoiceErrorStatusEnum, invoiceErrorStatusLocoKeys } from '../enum/invoice-error-status-enum';
import { InvoiceStateEnum, InvoiceStateTitle } from '../enums/invoice-state-enum';
import { InvoiceWithdrawalMethodEnum } from '../enums/invoice-withdrawal-method-enum';
import { useInvoiceDetails } from '../hooks/use-invoice-details';
interface InvoiceDetailsInterfaceProps {
  invoiceId: number | null;
  onCloseModal: () => void;
}
const renderWithdrawalDetails = (details: {
  [key: string]: string;
}) => {
  return Object.entries(details).map(([key, value]) => {
    const item = `${key}: ${value}`;
    return <span key={item}>{item}</span>;
  });
};
export const InvoiceDetailsModal = t0 => {
  const $ = _c(27);
  const {
    invoiceId,
    onCloseModal
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const router = useRouter();
  const purchaseInvoiceId = router.query.purchaseInvoiceId as string;
  const [visibleErrors, setVisibleErrors] = useState(3);
  let t1;
  if ($[0] !== invoiceId) {
    t1 = {
      invoiceId
    };
    $[0] = invoiceId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    invoiceDetails
  } = useInvoiceDetails(t1);
  let t2;
  if ($[2] !== router.query) {
    t2 = getQuery(router.query, ["purchaseInvoiceId"]);
    $[2] = router.query;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    unrelatedQuery
  } = t2;
  let t3;
  if ($[4] !== onCloseModal || $[5] !== purchaseInvoiceId || $[6] !== router || $[7] !== unrelatedQuery) {
    t3 = () => {
      onCloseModal();
      setVisibleErrors(3);
      if (purchaseInvoiceId) {
        router.replace("/affiliate-dashboard", {
          query: unrelatedQuery
        }, {
          shallow: true
        });
      }
    };
    $[4] = onCloseModal;
    $[5] = purchaseInvoiceId;
    $[6] = router;
    $[7] = unrelatedQuery;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onClose = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setVisibleErrors(_temp);
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const loadMore = t4;
  const showButton = invoiceDetails && invoiceDetails.errors.length > 3 && invoiceDetails.errors.length >= visibleErrors;
  const t5 = !!invoiceId;
  let t6;
  if ($[10] !== onClose) {
    t6 = () => onClose();
    $[10] = onClose;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("dashboard.affiliate.state.invoice_details.modal_title");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== invoiceDetails || $[15] !== showButton || $[16] !== t || $[17] !== user?.dashboardLocale || $[18] !== user?.dateFormat || $[19] !== user?.timezone || $[20] !== visibleErrors) {
    t8 = invoiceDetails ? <><div className="mb-8 flex gap-3"><div className="flex grow flex-col gap-3"><span className="text-base">{t("global.name")}</span><span className="text-text-primary">{invoiceDetails.purchaseInvoice.vendor.firstName}{" "}{invoiceDetails.purchaseInvoice.vendor.lastName}</span></div><div className="flex grow flex-col gap-3"><span className="text-base">{t("dashboard.affiliate.state.invoice_details.amount")}</span><span className="text-text-primary">{currencyFormat(centsToUnits(invoiceDetails.purchaseInvoice.amount), invoiceDetails.purchaseInvoice.currency, user?.dashboardLocale)}</span></div><div className="flex grow flex-col gap-3"><span className="text-base">{t("dashboard.affiliate.state.invoice_details.invoice_number")}</span><span className="text-text-primary">#{invoiceDetails.purchaseInvoice.number}</span></div><div className="flex grow flex-col gap-3"><span className="text-base">{t("dashboard.affiliate.state.invoice_details.invoice_status")}</span><span className="text-text-primary">{t(InvoiceStateTitle[InvoiceStateEnum.unpaid])}</span></div><div className="flex grow flex-col gap-3"><span className="text-base">{t("global.date")}</span><span className="text-text-primary">{dateFormat(invoiceDetails.purchaseInvoice.date, {
              dateFormat: user?.dateFormat,
              timeZone: user?.timezone
            })}</span></div></div>{!!invoiceDetails.errors.length && <div className="mb-6"><h3 className="mb-4 text-[20px]">{t("dashboard.affiliate.state.invoice_details.history_title")}</h3><div className="tablet:max-h-[400px] max-h-[250px] overflow-y-auto">{invoiceDetails.errors.slice(0, visibleErrors).map((error, index) => <div key={`${error.date}-${index}`} className="border-border-100 mb-3 flex rounded-lg border p-3"><div className="mt-1 flex h-7 flex-[25_1_0%]"><Badge color={error.status === InvoiceErrorStatusEnum.Failed ? "red" : "lightGray"} size="lg">{t(invoiceErrorStatusLocoKeys[error.status])}</Badge></div><div className="flex flex-[75_1_0%] flex-col gap-2"><p className="text-text-primary flex gap-1 text-base">{error.errorMessage ? <TransLoco t={t} i18nKey="dashboard.affiliate.state.invoice_details.default_error_bank" values={{
                  withdrawalMethod: t(InvoiceWithdrawalMethodEnum[error.withdrawalMethod]),
                  errorMessage: error.errorMessage
                }} components={{
                  b: <b />
                }} /> : t("dashboard.affiliate.state.invoice_details.default_error_massage")}{error.errorMessageOriginal && <Popover label={error.errorMessageOriginal}>{_temp2}</Popover>}</p><div className="flex gap-3"><div className="flex gap-1"><span className="text-text-link">{t(InvoiceWithdrawalMethodEnum[error.withdrawalMethod])}</span><Popover label={<div className="flex flex-col items-start gap-2">{renderWithdrawalDetails(error.withdrawalDetails)}</div>}>{_temp3}</Popover></div><span>{dateFormat(error.date, {
                    dateFormat: user?.dateFormat,
                    timeZone: user?.timezone
                  })}</span></div></div></div>)}</div></div>}{showButton && <div className="flex justify-center"><Button onClick={() => loadMore()} variant="secondary" size="md">{t("dashboard.affiliate.state.invoice_details.load_more")}</Button></div>}</> : <div className="m-auto table"><Loader type="dark" /></div>;
    $[14] = invoiceDetails;
    $[15] = showButton;
    $[16] = t;
    $[17] = user?.dashboardLocale;
    $[18] = user?.dateFormat;
    $[19] = user?.timezone;
    $[20] = visibleErrors;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t5 || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = <Modal opened={t5} onClose={t6} title={t7}>{t8}</Modal>;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
};
function _temp(prevState) {
  return prevState + 3;
}
function _temp2(show) {
  return <InfoCircleIcon className={twJoin("transition-base size-4", show ? "text-icon-accent" : "text-icon-primary")} />;
}
function _temp3(show_0) {
  return <InfoCircleIcon className={twJoin("transition-base size-4", show_0 ? "text-icon-accent" : "text-icon-primary")} />;
}